import React, { useEffect, useState,useMemo } from "react";
import { ViewCallProps } from "./view-call-props";
import "../view-task/view-task.scss";
import "./view-call.scss";
import { formatDate, formatDateTime } from "../../../../../../../utils/utils";
import { getCallById, getTaskById } from "../../../../../../../api/campaign";
import { AlertComponent } from "../../../../../../../common/components";
import { useSetLoading } from "../../../../../../../common/hooks/appearance";

const CallView: React.FC<ViewCallProps> = (props: any) => {
  const { callId, leadDetails } = props;
  const [call, setCall] = useState<any>({
    id: 1,
    subject: "Client onboarding discussion",
    call_start_time: new Date("2025-06-07T10:30:00Z"),
    call_owner: "Ravi Kumar",
    call_purpose: "Introductory Call",
    call_agenda: "Discuss onboarding steps and assign account manager",
    call_for: "Client",
    related_to: "Campaign A",
    call_type: "Outgoing",
    outgoing_call_status: "Completed",
    call_start_date: new Date("2025-06-07"),
    owner: {
      id: 3,
      first_name: "John",
      last_name: "Doe",
    },
  });
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [loading, setLoading] = useState(false);

  const fetchCallDetails = async () => {
    setLoading(true);
    try {
      const response = await getCallById(
        callId,
        leadDetails.id,
        "Lead Details"
      );
      setCall(response?.data?.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while fetching the call."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };
  useEffect(() => {
    if (callId && leadDetails?.id) {
        fetchCallDetails();
    }
  }, [callId, leadDetails]);

  const fetchCallFor = () => {
    if (Array.isArray(call?.callFors)) {
      return call.callFors.map((item: any) => item.fullName).join(", ");  
    }
    else {
      return "-";
    }
  }

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <div className="campaign-view-task-view campaign-view-call-view">
      <div className="campaign-list-view-details-view-box-full-info">
        <div className="campaign-list-view-details-view-box-full-info-header-text">
          Call Information
        </div>
        <div className="campaign-list-view-details-view-box-full-info-data">
          {/* Left Section */}
          <div className="campaign-list-view-details-view-box-full-info-data-section">
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Call For
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {fetchCallFor() || "-"}
              </div>
            </div>
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Ongoing Call Status
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.outgoing_call_status || "-"}
              </div>
            </div>
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Owner
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.callOwner
                  ? `${call.callOwner.name}`
                  : "-"}
              </div>
            </div>
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Modified By
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.updatedBy
                  ? `${call.updatedBy.name}`
                  : "-"}
                <br />
                {formatDateTime(call?.updated_at || "-", true)}
              </div>
            </div>
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Created By
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.createdBy
                  ? `${call.createdBy.name}`
                  : "-"}
                <br />
                {formatDateTime(call?.created_at || "-", true)}
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="campaign-list-view-details-view-box-full-info-data-section">
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Call Type
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.call_type || "-"}
              </div>
            </div>
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Call Start Time
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.call_start_time != null
                  ? `On ${formatDateTime(call?.call_start_time, true)}`
                  : "-"}
              </div>
            </div>
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Subject
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.subject || "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="campaign-list-view-details-view-box-full-info purpose-of-outgoing-call-info-wrapper">
        <div className="campaign-list-view-details-view-box-full-info-header-text">
          Purpose Of Outgoing Call
        </div>
        <div className="campaign-list-view-details-view-box-full-info-data">
          <div className="campaign-list-view-details-view-box-full-info-data-section">
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Call Purpose
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.call_purpose || "-"}
              </div>
            </div>
          </div>
          <div className="campaign-list-view-details-view-box-full-info-data-section">
            <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                Call Agenda
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                {call?.call_agenda || "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
      {call?.call_duration && (
        <div className="campaign-list-view-details-view-box-full-info purpose-of-outgoing-call-info-wrapper">
          <div className="campaign-list-view-details-view-box-full-info-header-text">
            Outcome Of Outgoing Call
          </div>
          <div className="campaign-list-view-details-view-box-full-info-data">
            <div className="campaign-list-view-details-view-box-full-info-data-section">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Call Result
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {call?.call_results || "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {call?.call_duration && (call?.description) && <div className="campaign-list-view-details-view-box-full-info description-task">
        <div className="campaign-list-view-details-view-box-full-info-header-text">
          Description
        </div>
        <div className="campaign-list-view-details-view-box-full-info-description-box description-box-container">
          {call?.description || "-"}
        </div>
      </div>}
      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </div>
  );
};

export default CallView;
